import { downloadPoints } from '@/mocks/haijiao';

export default function Download() {
  return (
    <section id="download" className="border-b border-stone-200/80 bg-[#fdfaf6]">
      <div className="mx-auto max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-orange-600 via-orange-500 to-amber-400 px-6 py-10 md:px-12 md:py-14">
          <i className="ri-circle-fill absolute -right-6 -top-6 text-8xl text-white/10"></i>
          <i className="ri-circle-fill absolute -bottom-8 left-1/3 text-9xl text-white/10"></i>

          <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
            <div>
              <p className="flex items-center gap-2 text-sm font-semibold text-orange-100">
                <i className="ri-download-2-fill"></i> 海角社区客户端
              </p>
              <h2 className="mt-2 text-2xl font-extrabold leading-tight text-white md:text-3xl">
                下载海角社区，板块与话题随时随身刷
              </h2>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-orange-50">
                不在电脑前也能逛社区广场、参与帖子讨论。收藏分类圈子，话题更新第一时间提醒，冲浪不迷路。
              </p>

              <div className="mt-5 flex flex-wrap gap-2">
                {downloadPoints.map((p) => (
                  <span
                    key={p}
                    className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-white/15 px-3 py-1.5 text-xs font-medium text-white"
                  >
                    <i className="ri-check-line text-orange-100"></i> {p}
                  </span>
                ))}
              </div>
            </div>

            <div className="flex flex-col items-stretch gap-3 lg:items-end">
              <div className="w-full max-w-sm rounded-2xl bg-white/95 p-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-orange-600 text-white">
                    <i className="ri-sun-line text-xl"></i>
                  </span>
                  <div>
                    <p className="text-sm font-bold text-stone-900">海角社区 App</p>
                    <p className="text-xs text-stone-500">广场 · 板块 · 圈子 · 开黑</p>
                  </div>
                </div>
                <div className="mt-4 grid grid-cols-2 gap-2">
                  <a href="#download" className="flex items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-stone-900 px-3 py-2.5 text-xs font-semibold text-white transition-colors hover:bg-stone-800">
                    <i className="ri-apple-fill text-base"></i> App Store
                  </a>
                  <a href="#download" className="flex items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-stone-900 px-3 py-2.5 text-xs font-semibold text-white transition-colors hover:bg-stone-800">
                    <i className="ri-android-fill text-base"></i> Android
                  </a>
                  <a href="#download" className="flex items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-orange-200 bg-orange-50 px-3 py-2.5 text-xs font-semibold text-orange-700 transition-colors hover:bg-orange-100 col-span-2">
                    <i className="ri-qr-scan-line text-base"></i> 扫码体验 Web 版
                  </a>
                </div>
              </div>
              <p className="text-center text-xs text-orange-100 lg:text-right">支持 iOS / Android / Web · 免费注册</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}